/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamRevisionBotexamidVisualizeQueryResponse,
  GetApiV1ExamRevisionBotexamidVisualizePathParams,
  GetApiV1ExamRevisionBotexamidVisualizeQueryParams,
  GetApiV1ExamRevisionBotexamidVisualize400,
  GetApiV1ExamRevisionBotexamidVisualize401,
  GetApiV1ExamRevisionBotexamidVisualize404,
  GetApiV1ExamRevisionBotexamidVisualize500,
} from "../../types/examRevisionController/GetApiV1ExamRevisionBotexamidVisualize.ts";

function getGetApiV1ExamRevisionBotexamidVisualizeUrl(
  botExamId: GetApiV1ExamRevisionBotexamidVisualizePathParams["botExamId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/exam/revision/${botExamId}/visualize` as const,
  };
  return res;
}

/**
 * @description Retorna os dados completos de visualização de uma prova gerada por IA, incluindo título, instrução e todas as questões em pt-BR com suas traduções para outros idiomas. **(Requer Authorization para autenticação)**
 * @summary Visualizar prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/:botExamId/visualize}
 */
export async function getApiV1ExamRevisionBotexamidVisualize(
  botExamId: GetApiV1ExamRevisionBotexamidVisualizePathParams["botExamId"],
  params?: GetApiV1ExamRevisionBotexamidVisualizeQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamRevisionBotexamidVisualizeQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamRevisionBotexamidVisualize400
      | GetApiV1ExamRevisionBotexamidVisualize401
      | GetApiV1ExamRevisionBotexamidVisualize404
      | GetApiV1ExamRevisionBotexamidVisualize500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamRevisionBotexamidVisualizeUrl(botExamId).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
